export default function Hero () {
    return (
        <section id='hero-solutions'>
            <h1 className="f2 header-title" data-aos="fade-up">Our Services</h1>
            <p className="w-75 h5 text-center" data-aos="fade-up" style={{zIndex: '999', color: '#fff'}}>We are your partner in creating an actionable and efficient facility management, fire safety and security systems</p>
        </section>
    );
}